<app-content>
  <app-breadcrumbs>
    <li>
      Odpady komunalne
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Odpady komunalne
    </h2>
    @if (loading()) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    } @else {
      <div class='row'>
        <div class="col-12">
          @if (authed) {
            <app-alert class="d-inline-block" [closable]="false">
              Możesz dostawać powiadomienia z wybranych obszarów! <a routerLink="/ustawienia"><strong>
              Przejdź do konfiguracji powiadomień</strong></a>
            </app-alert>
          } @else {
            <app-alert class="d-inline-block" [closable]="false">
              Powiadomienia o odpadach komunalnych wymagają zalogowania. <strong>Zaloguj się</strong>
              aby skonfigurować obszary powiadomień.
            </app-alert>
          }
        </div>
      </div>
      <div class='row'>
        <div class='col-md-8'>
          <ul class='item-list'>
            <li *ngFor='let item of (areas() || [])'>
              <div>
                <a [routerLink]='item.uuid'>{{ item.name }}</a>
              </div>
              <div>
                <small>{{ item.streetList }}</small>
              </div>
            </li>
          </ul>
          <app-alert content='Brak wynników'
                     *ngIf='!areas().length'
                     [closable]='false'>
          </app-alert>
        </div>
      </div>
    }
  </section>
</app-content>
